module.exports = __webpack_public_path__ + "static/media/OK.228f520b.svg";